import type { NDateLocale } from './enUS'
import { enUS } from 'date-fns/locale'

const dateUrPK: NDateLocale = {
  name: 'ur-PK',
  locale: enUS
}

export default dateUrPK
